import gql from 'graphql-tag'
import di from 'di'

import addList from '@wittignl/js-core/apollo/mutations/addList'
import updateList from '@wittignl/js-core/apollo/mutations/updateList'
import deleteList from '@wittignl/js-core/apollo/mutations/deleteList'
import update from '@wittignl/js-core/apollo/mutations/update'

export default {

    create: function(project){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($projectInput: CreateProjectInput!) {
                    createProject(input: $projectInput){
                        id
                        title
                        code
                        startDate
                        endDate
                        projectManager
                        munisenseGroupId
                        createdAt
                        updatedAt
                    }
                }`,

            variables: {
                projectInput: project
            },

            updateQueries: {
                AllProjects: addList('createProject', 'allProjects.items'),
            }
        });
    },

    update: function(project){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($projectInput: UpdateProjectInput!) {
                    updateProject(input: $projectInput){
                        id
                        title
                        code
                        startDate
                        endDate
                        projectManager
                        actionDeadline
                        munisenseGroupId
                        createdAt
                        updatedAt
                    }
                }`,

            variables: {
                projectInput: project
            },

            updateQueries: {
                AllProjects: updateList('updateProject', 'allProjects.items'),
                FindProject: update('updateProject', 'findProject')
            }
        });
    },

    delete: function(projectId){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($projectId: ID!) {
                    deleteProject(id: $projectId)
                }`,

            variables: {
                projectId: projectId
            },

            updateQueries: {
                AllProjects: deleteList('deleteProject', 'allProjects.items', projectId)
            }
        });
    }
}
